/* Progressive enhancement exclusively for new RESET LP sections. No cart code or global styling mutation. */
(() => {
  if (window.qeviqResetAnglesReady) return;
  window.qeviqResetAnglesReady = true;
  const controllers = new Map();
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  function enhance(scope = document) {
    scope.querySelectorAll('.qreset').forEach(root => {
      if (controllers.has(root) || reduced.matches || !('IntersectionObserver' in window)) return;
      const items = [...root.querySelectorAll('[data-qr-reveal]')];
      if (!items.length) return;
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.06, rootMargin: '0px 0px -24px 0px' });
      root.classList.add('qreset--motion');
      items.forEach(item => observer.observe(item));
      controllers.set(root, observer);
    });
  }
  function clean(scope) {
    controllers.forEach((observer, root) => {
      if (scope === root || scope.contains(root)) {
        observer.disconnect(); root.classList.remove('qreset--motion'); controllers.delete(root);
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => enhance(), {once:true});
  else enhance();
  document.addEventListener('shopify:section:load', e => enhance(e.target));
  document.addEventListener('shopify:section:unload', e => clean(e.target));
  reduced.addEventListener('change', () => { clean(document); enhance(); });
})();

/* RESET desktop purchase panel follows the full eight-image gallery. */
(() => {
  if (window.qeviqResetStickyReady) return;
  window.qeviqResetStickyReady = true;
  let observer, panel;
  function bind() {
    if (observer) observer.disconnect();
    if (panel) panel.removeAttribute('data-qreset-sticky-ready');
    panel = null;
    if (!document.querySelector('[data-qreset-root]') || !('ResizeObserver' in window)) return;
    panel = document.querySelector('.product-info--qeviq .product__info-container');
    if (!panel) return;
    const measure = () => {
      panel.style.setProperty('--qreset-info-height', Math.ceil(panel.getBoundingClientRect().height) + 'px');
      panel.setAttribute('data-qreset-sticky-ready', '');
    };
    observer = new ResizeObserver(measure);
    observer.observe(panel);
    measure();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind, {once:true});
  else bind();
  document.addEventListener('shopify:section:load', bind);
  document.addEventListener('shopify:section:unload', () => { if (observer) observer.disconnect(); });
})();
